<template>
    <div class="fill-height of-y d-flex flex-column">
        <div class="flex-grow-1 of-y d-flex flex-column fill-height">

            <div class="of-y flex-column" style="height: 30%">
                <div class="d-flex align-center">
                    <v-card-title class="flex-grow-1 flex-equal py-2">
                        Summary
                    </v-card-title>
                    <div class="flex-grow-1 flex-equal pr-2 d-flex align-center">
                        <v-text-field
                                v-model="search"
                                prepend-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                                class="pa-0 ma-0 flex-grow-1"
                        ></v-text-field>
                        <v-btn
                                :disabled="false"
                                @click="exportReportData"
                                color="primary"
                                small
                                :loading="exportingData"
                                class="ml-2"
                        >
                            Export
                        </v-btn>
                    </div>
                </div>

                <v-data-table
                        :search="search"
                        dense
                        fixed-header
                        height="100%"
                        class="flex-grow-1 of-y"
                        hide-default-footer
                        :headers="summaryHeaders"
                        :items="summary"
                        :options="{itemsPerPage: summary.length}"
                ></v-data-table>
            </div>
            <v-divider></v-divider>

            <div class="of-y d-flex flex-column flex-grow-1 flex-equal">
                <div class="d-flex align-center">
                    <v-card-title class="flex-grow-1 flex-equal py-2">
                        Detail
                    </v-card-title>
                    <div class="flex-grow-1 flex-equal pr-2">
                        <v-text-field
                                v-model="searchDetail"
                                prepend-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                                class="pa-0 ma-0"
                        ></v-text-field>
                    </div>
                </div>
                <v-data-table
                        :search="searchDetail"
                        dense
                        fixed-header
                        height="100%"
                        class="flex-grow-1 of-y"
                        hide-default-footer
                        :headers="headers"
                        :items="detail"
                        :options="{itemsPerPage: detail.length}"
                ></v-data-table>
            </div>

        </div>


    </div>
</template>

<script>

import {mapGetters} from "vuex";
import {format} from "date-fns";

export default {
    components: {},
    props: {
        selectedFarm: Number,
        selectedDate: Date
    },
    data() {
        return {
            search: null,
            searchDetail: null,
            summaryHeaders: [
                {text: "Farm ", value: "farmDescription"},
                {text: "Block", value: "blockDescription"},
                {text: "Variety", value: "varietyDescription"},
                {text: "Picked", value: "binsPicked"},
                {text: "Received", value: "binsReceived"},
                {text: "Avg Transit Time(m)", value: "avgTransitTime"},
            ],
            headers: [
                {text: "Picked", value: "pickStr"},
                {text: "Bin ID", value: "binID"},
                {text: "Farm", value: "farmDescription"},
                {text: "Block", value: "blockDescription"},
                {text: "Variety", value: "varietyDescription"},
                {text: "Picked By", value: "employees"},
                {text: "Received", value: "receiveStr"},
                {text: "Transit Time(m)", value: "transitTime"},
            ],
            data: {
                summary: [],
                detail: [],
            },
            exportingData: false
        }
    },
    watch: {
        selectedFarm: {
            immediate: true,
            handler() {
                this.getTraceData()
            }
        },
        selectedDate(val) {
            if (val) {
                this.getTraceData()
            }
        }
    },
    methods: {
        async getTraceData() {
            try {
                this.loading = true;
                this.data = await this.$newReq(
                        'POST',
                        `reports/binTrace`,
                        {
                            date: this.selectedDate,
                            farms: this.selectedFarm ? [this.selectedFarm] : this.availableFarmIDs,
                        },
                )
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.loading = false
            }
        },
        exportReportData() {
            this.exportingData = true;
            console.log(this.farmsRef)
            this.$newReqDownloadFile(
                    'POST',
                    `reports/binTrace/export`,
                    {
                        start: this.selectedDate,
                        farms: this.selectedFarm ? [this.selectedFarm] : this.availableFarmIDs,
                    },
                    `Bin Trace Report ${format(this.selectedDate, 'yyyy-MM-dd')}.xlsx`
            )
                    .then(data => {
                        console.log(data)
                    })
                    .catch(e => {
                        console.log(e)
                        this.$snack.netWorkError();
                    })
                    .finally(() => {
                        this.exportingData = false
                    })
        }
    },
    computed: {
        ...mapGetters(['farmsRef', 'availableFarms']),
        availableFarmIDs() {
            return (this.availableFarms.length ? this.availableFarms : this.farms).map((farm) => farm.id)
        },
        farm() {
            return this.selectedFarm ? this.farmsRef[this.selectedFarm] : null
        },
        summary() {
            return [...this.data.summary].sort((a,b) => a.farmDescription > b.farmDescription ? 1 : -1)
        },
        detail() {
            return [...this.data.detail].sort((a,b) => a.binPicked > b.binPicked ? 1 : -1)
        }
        // rows() {
        //     return this.data.map(row => {
        //         return {
        //             farmID: row.farm.id,
        //             farm: row.farm.description,
        //             employee: row.emp.fullName,
        //             empCode: row.emp.empCode,
        //             clockIn: row.clockInStr,
        //             lastAction: row.lastActionStr,
        //             binUnits: row.binUnits,
        //             piecework: row.pieceWorkStr,
        //             pWUnits: row.pieceWorkUnits,
        //             hours: row.hours,
        //         }
        //     }).filter((row) => this.selectedFarm ? row.farmID === this.selectedFarm : true)
        // }
    },
}
</script>

<style scoped>

</style>